<template>
  <section class="section">
    <div class="container-lg">
      <div class="section__header">
        <h1 class="section__title  section__title--lg">
          {{ in18['hello_label'] }} {{ user.full_name }}
        </h1>
        <div class="section__text">
          {{ in18['order_description'] }}
        </div>
      </div>
      <hr>
      <h2 class="section__title mt-5">
        {{ in18['order_title'] }}
      </h2>
      <template v-if="user.hasOwnProperty('orders') && user.orders.length > 0">
        <div class="table-wrapper">
          <table class="orders-table">
            <thead>
            <tr>
              <th>{{ in18['order_date'] }}</th>
              <th>{{ in18['order_number'] }}</th>
              <th>{{ in18['order_recipient'] }}</th>
              <th>{{ in18['order_amount'] }}</th>
              <th colspan="2">{{ in18['order_status'] }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in user.orders">
              <td class="text-gray">{{ order.created_at }}</td>
              <td class="fw-500">{{ order.prefix_id }}</td>
              <td class="text-gray-dark">{{ order.full_name }}</td>
              <td class="fw-500">{{ order.formatted_total_price_with_tax }}</td>
              <td>
                <div :class="'orders-table__status--' + order.status" class="orders-table__status">
                  {{ order.status_label }}
                </div>
              </td>
              <td class="orders-table__action">
                <a :href="order.invoice_link" :title="in18['order_download']" class="link  link--gray  link--icon">
                  <img :alt="in18['order_pdf']" class="link__icon" height="20" src="/shop/images/eye-icon.svg"
                       width="20">
                  {{ in18['order_pdf'] }}
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="section__text">
          {{ in18['order_empty_list'] }}
        </div>
      </template>
      <hr>
    </div><!-- /.container-lg -->
  </section><!-- /.section -->
</template>

<script>
export default {
  name:  "ProfileOrderList",
  props: {
    user: {
      type: Object
    },
    in18: {
      type: Object
    }
  },
};
</script>
